import { apiStatusError, fetchError } from 'FRONTEND/utils/errors';
import { API_SMUR_TEAMS } from 'FRONTEND/utils/routes';

export const getSmurTeams = async() => {
  try {
    const res = await fetch(API_SMUR_TEAMS);
    apiStatusError({ response: res });
    return await res.json();
  } catch (error) {
    throw fetchError({ error });
  }
};


export const getFacilities = async() => {
  try {
    const res = await fetch('api/facility').then((data) => {
      apiStatusError({ response: data });
      return data.json();
    });
    return res;
  } catch (error) {
    throw fetchError({ error });
  }
};

export const convertGoogleGeolocationToMapPosition = (googleGeolocation) => {
  return { lat: googleGeolocation.geometry.location.lat(), lng: googleGeolocation.geometry.location.lng() };
};
